"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FieldValidator_1 = __importDefault(require("./FieldValidator"));
console.debug('INFO FormValidator.ts loaded');
var FormValidator = /** @class */ (function () {
    function FormValidator(form) {
        var _this = this;
        this.form = form;
        this.form
            .querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=file]),select,textarea')
            .forEach(function (item) {
            item.addEventListener('blur', function () {
                _this.validateField(item);
            });
        });
        // for all checkbox groups with required attribute, remove required attribute when at least one checkbox is checked
        this.form.querySelectorAll('input[type=checkbox][required]').forEach(function (item) {
            item.addEventListener('click', function () {
                var fieldset = item.closest('.js-checkbox');
                var isOneChecked = fieldset.querySelectorAll(':checked').length > 0;
                fieldset.querySelectorAll('.c-checkbox__input').forEach(function (checkbox) {
                    if (isOneChecked) {
                        checkbox.removeAttribute('required');
                    }
                    else {
                        checkbox.setAttribute('required', 'required');
                        checkbox.dataset.requiredChanged = 'true';
                    }
                });
            });
        });
        this.form.querySelectorAll('input[type=radio],input[type=checkbox]').forEach(function (item) {
            item.addEventListener('click', function () {
                _this.validateField(item);
            });
        });
        this.form.querySelectorAll('.js-datepicker').forEach(function (item) {
            item.addEventListener('bronson_datepickerClose', function () {
                _this.validateField(item.querySelector('input'));
            });
        });
        this.genericErrorId = '#error-' + this.form.id;
    }
    FormValidator.prototype.validateForm = function (isSubmit) {
        if (!this.form.noValidate) {
            this._resetFormValidationStatus();
            this._initializeFieldValidators();
            var valid = this.form.checkValidity();
            if (valid === false) {
                this._setFormValidationStatus(isSubmit);
            }
            return valid;
        }
        else {
            return true;
        }
    };
    FormValidator.prototype.validateField = function (field) {
        if (!field.hasAttribute('data-novalidate')) {
            this._resetFieldValidationStatus(field);
            var valid = this.fieldIsValid(field);
            if (valid === false) {
                this._setFieldValidationStatus(field);
            }
            else if (this.form.checkValidity() === true) {
                this.form.querySelector(this.genericErrorId).classList.add('u-hide');
            }
            return valid;
        }
        else {
            return true;
        }
    };
    FormValidator.prototype.fieldIsValid = function (field) {
        this._initializeFieldValidator(field);
        return field.checkValidity();
    };
    /**
     * reset existing validation status
     */
    FormValidator.prototype._resetFormValidationStatus = function () {
        this.form.querySelector(this.genericErrorId).classList.remove('u-hide');
        this.form.querySelectorAll('[aria-invalid="true"]').forEach(function (item) {
            item.removeAttribute('aria-invalid');
        });
        this.form.querySelectorAll('.c-error-message').forEach(function (item) {
            item.classList.add('u-hide');
        });
        this.form.querySelectorAll('input:invalid,select:invalid,textarea:invalid').forEach(function (item) {
            item.setCustomValidity('');
        });
    };
    FormValidator.prototype._resetFieldValidationStatus = function (field) {
        field.removeAttribute('aria-invalid');
        if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
            var attribute = field.dataset.targetId;
            this.form.querySelectorAll("[data-target-id=".concat(attribute, "]")).forEach(function (item) {
                item.removeAttribute('aria-invalid');
            });
        }
        if (field.parentElement.nextElementSibling) {
            field.parentElement.nextElementSibling.classList.add('u-hide');
        }
        else {
            var attribute = field.dataset.targetId;
            if (attribute) {
                this.form.querySelectorAll('.' + attribute).forEach(function (item) {
                    item.classList.add('u-hide');
                });
            }
        }
    };
    /**
     * set validation status for all invalid form fields
     */
    FormValidator.prototype._setFormValidationStatus = function (isSubmit) {
        var _this = this;
        this.form.querySelector(this.genericErrorId).classList.remove('u-hide');
        this.form.querySelectorAll('input:invalid,select:invalid,textarea:invalid').forEach(function (item) {
            _this._setFieldValidationStatus(item);
        });
        if (isSubmit) {
            this._scrollToFirstError();
        }
    };
    FormValidator.prototype._setFieldValidationStatus = function (field) {
        var validator = this._getFieldValidator(field);
        if (validator.getMessages().length > 0) {
            field.setAttribute('aria-invalid', 'true');
            if (field.getAttribute('type') === 'radio' || field.getAttribute('type') === 'checkbox') {
                var attribute = field.dataset.targetId;
                this.form.querySelectorAll("[data-target-id=".concat(attribute, "]")).forEach(function (item) {
                    item.setAttribute('aria-invalid', 'true');
                });
            }
            if (field.parentElement.nextElementSibling) {
                field.parentElement.nextElementSibling.innerHTML = validator.getMessages()[0];
                field.parentElement.nextElementSibling.classList.remove('u-hide');
            }
            else {
                var attribute = field.dataset.targetId;
                if (attribute) {
                    this.form.querySelectorAll('.' + attribute).forEach(function (item) {
                        item.innerHTML = validator.getMessages()[0];
                        item.classList.remove('u-hide');
                    });
                }
            }
        }
    };
    /**
     * initialize (custom) validators and messages
     */
    FormValidator.prototype._initializeFieldValidators = function () {
        var _this = this;
        // initialize field validators for all fields
        this.form.querySelectorAll('input,select,textarea').forEach(function (item) {
            _this._initializeFieldValidator(item);
        });
    };
    FormValidator.prototype._initializeFieldValidator = function (field) {
        var fieldValidator = this._getFieldValidator(field);
        fieldValidator.runCustomValidations();
    };
    FormValidator.prototype._getFieldValidator = function (field) {
        var validator = field.validator;
        if (!validator || field.dataset.requiredChanged === 'true') {
            validator = new FieldValidator_1.default(field);
            field.validator = validator;
        }
        return validator;
    };
    FormValidator.prototype._scrollToFirstError = function () {
        var element = this.form.querySelector(this.genericErrorId);
        if (element) {
            var jumpnav = document.querySelector('.js-section-nav');
            var jumpnavHeight = 0;
            if (jumpnav) {
                jumpnavHeight = jumpnav.scrollHeight;
            }
            var bodyRect = document.body.getBoundingClientRect(), elemRect = element.getBoundingClientRect(), offset = elemRect.top - bodyRect.top - jumpnavHeight - 200;
            window.scrollTo(0, offset);
        }
        else {
            console.debug('Error: FormValidator.ts: Error element is null.');
        }
    };
    return FormValidator;
}());
exports.default = FormValidator;
